import { debounce } from "lodash";

import { InitPage } from "../../index";

declare var App: any;
declare const client_code: string;
declare const store_code: string;
declare const orderId: string;

class ShippingInboundLiveMonitoring {
  constructor() {
    if (!orderId) {
      return;
    }

    let _this = this;
    const channel = "Inbound::OrderReceivingChannel";
    const tenant = client_code;
    const location = store_code;

    $(() => {
      App.cable.subscriptions.create(
        { channel, tenant, location },
        {
          connected() {},
          disconnected() {},
          received: (data: any) => _this.reload(data),
        },
      );
    });
  }

  reload = debounce((data: any) => {
    const { body } = data;

    if (body.order_id === orderId && body.location === store_code) {
      $.ajax({
        dataType: "jsonp",
        url: `/${client_code}/${store_code}/shipping/inbound/live_monitoring_orders/${orderId}.js`,
      });
    }
  }, 1000);
}

export function LoadPage() {
  InitPage("live_monitoring_orders", () => new ShippingInboundLiveMonitoring());
}
